import React, {PropsWithChildren} from 'react';
import classnames from 'classnames';
import styles from './styles.module.scss';

interface FooterBarProps extends PropsWithChildren<{}> {
  containerClassnames?: string;
}

const FooterBar = ({children, containerClassnames}: FooterBarProps) => {
  return (
    <div className={classnames(styles.footerBar, containerClassnames)}>
      {children}
    </div>
  );
};

export default FooterBar;
